import { QueryClient } from '@tanstack/react-query';
import { shouldRetryQuery, queryRetryDelay } from '@/lib/api-errors';

// Single shared client (imported by main.tsx and by the reconnect sweep in
// App.tsx). Retry policy lives here, not scattered across pages: transient
// failures (offline/timeout/429/5xx) back off and retry, permanent ones
// (401/403/404/other 4xx) fail fast so error UI appears instead of a spinner.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => shouldRetryQuery(failureCount, error),
      retryDelay: (attemptIndex, error) => queryRetryDelay(attemptIndex, error),
      staleTime: 30000,
      gcTime: 10 * 60 * 1000,
    },
  },
});
